import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { useEffect, useMemo, useRef } from "react";
import { useTranslations } from "use-intl";
import { useTrackError } from "../../providers/TrackErrorProvider";
import { useErrors } from "./useErrors";
import { useSetBlockchainActionErrorsFragment } from "./useSetBlockchainActionErrors.fragment";
export const useSetBlockchainActionErrors = errorKeys => {
  const $ = _c(22);
  const t = useTranslations("wallet.BlockchainActionErrors");
  let t0;
  let t1;
  if ($[0] !== errorKeys) {
    t1 = errorKeys ? errorKeys.map(_temp) : [];
    $[0] = errorKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const errors = t0;
  const {
    setReceiptErrors,
    setActionError,
    setInsufficientFundsActionError
  } = useErrors();
  let t2;
  let t3;
  if ($[2] !== errors || $[3] !== setReceiptErrors || $[4] !== t) {
    t2 = function setReceiptErrorsFromBlockchainActionResponse() {
      const receiptErrors = errors.reduce((acc, value) => {
        if (value.__typename === "OrderNotFound") {
          const key = value.item.id;
          acc[key] = t("orderNotFound");
        }
        return acc;
      }, {});
      setReceiptErrors(receiptErrors);
    };
    t3 = [errors, setReceiptErrors, t];
    $[2] = errors;
    $[3] = setReceiptErrors;
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== errors || $[8] !== setActionError || $[9] !== setInsufficientFundsActionError || $[10] !== t) {
    t4 = function setActionErrorFromBlockchainActionResponse() {
      let actionError;
      const errorTypenames = new Set(errors.filter(_temp2).map(_temp3));
      let insufficientFundsActionError = false;
      if (errorTypenames.has("OrderChainMismatchError")) {
        actionError = t("orderChainMismatch");
      } else {
        if (errorTypenames.has("OrderProtocolMismatchError")) {
          actionError = t("orderProtocolMismatch");
        } else {
          if (errorTypenames.has("UnableToFulfillQuantityError")) {
            actionError = t("unableToFulfillQuantity");
          } else {
            if (errorTypenames.has("InsufficientFundError")) {
              actionError = t("insufficientFunds");
              insufficientFundsActionError = true;
            } else {
              if (errorTypenames.has("OrderLeverageUserZeroBalanceError")) {
                actionError = t("insufficientOfferBalance");
              } else {
                if (errorTypenames.has("OrderLeverageBalanceRatioError")) {
                  actionError = t("insufficientOfferBalanceForExisting");
                } else {
                  if (errorTypenames.has("OrderFinalizedError")) {
                    actionError = t("noEligibleOrders");
                  } else {
                    if (errorTypenames.has("EstimateGasFailureError")) {
                      actionError = t("orderNoLongerValidRefresh");
                    } else {
                      if (errorTypenames.has("TransferLockedError")) {
                        actionError = t("nftLocked");
                      } else {
                        if (errorTypenames.has("OrderNotVendableError")) {
                          actionError = t("orderNoLongerValid");
                        } else {
                          if (errorTypenames.has("OrderProviderError")) {
                            actionError = t("thirdPartyMarketplaceError");
                          } else {
                            if (errorTypenames.has("NoTraitItemsFoundError")) {
                              actionError = t("noItemsWithTrait");
                            } else {
                              if (errorTypenames.has("InsufficientMintsRemainingError")) {
                                actionError = t("insufficientMintsRemaining");
                              } else {
                                if (errorTypenames.has("MinterNotEligibleForActiveDropStageError")) {
                                  actionError = t("notEligibleForDropStage");
                                } else {
                                  if (errorTypenames.has("MintQuantityMoreThanAllocatedForMinterError")) {
                                    actionError = t("notEligibleForSelectedQuantity");
                                  } else {
                                    if (errorTypenames.has("DropNotFoundError")) {
                                      actionError = t("dropNotFound");
                                    } else {
                                      if (errorTypenames.has("DropNotMintingError")) {
                                        actionError = t("dropNotMinting");
                                      } else {
                                        if (errorTypenames.has("CrossChainPayerNotAllowedForDropError")) {
                                          actionError = t("crossChainPayerNotAllowedForDrop");
                                        } else {
                                          if (errorTypenames.has("OrderPriceChangeError")) {
                                            actionError = t("orderPriceChange");
                                          } else {
                                            if (errorTypenames.has("UnsupportedSwapError")) {
                                              actionError = t("unsupportedSwap");
                                            } else {
                                              if (errorTypenames.size > 0) {
                                                actionError = t("unexpectedError");
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      setActionError(actionError);
      setInsufficientFundsActionError(insufficientFundsActionError);
    };
    $[7] = errors;
    $[8] = setActionError;
    $[9] = setInsufficientFundsActionError;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== errors || $[13] !== setActionError || $[14] !== t) {
    t5 = [errors, setActionError, t];
    $[12] = errors;
    $[13] = setActionError;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t4, t5);
  const trackError = useTrackError();
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const reportedErrorsRef = useRef(t6);
  let t7;
  let t8;
  if ($[17] !== errors || $[18] !== t || $[19] !== trackError) {
    t7 = function reportErrorsToSentry() {
      if (reportedErrorsRef.current !== errors) {
        errors.forEach(error_2 => {
          bb85: switch (error_2.__typename) {
            case "OrderNotFound":
              {
                trackError(new Error(t("orderNotFound")), {
                  extra: {
                    item: error_2.item.id
                  },
                  tags: {
                    chain: error_2.item.chain.identifier
                  }
                });
                break bb85;
              }
            case "OrderChainMismatchError":
              {}
            case "OrderProtocolMismatchError":
              {}
            case "UnableToFulfillQuantityError":
              {}
            case "InsufficientFundError":
              {}
            case "OrderLeverageUserZeroBalanceError":
              {}
            case "OrderLeverageBalanceRatioError":
              {}
            case "OrderFinalizedError":
              {}
            case "EstimateGasFailureError":
              {}
            case "TransferLockedError":
              {}
            case "OrderNotVendableError":
              {}
            case "OrderProviderError":
              {}
            case "NoTraitItemsFoundError":
              {}
            case "UnsupportedSwapError":
              {
                trackError(new Error(error_2.__typename));
                break bb85;
              }
            default:
              {
                trackError(new Error(t("unexpectedBlockchainActionError")), {
                  extra: {
                    error: error_2.__typename
                  }
                });
              }
          }
        });
        reportedErrorsRef.current = errors;
      }
    };
    t8 = [errors, trackError, t];
    $[17] = errors;
    $[18] = t;
    $[19] = trackError;
    $[20] = t7;
    $[21] = t8;
  } else {
    t7 = $[20];
    t8 = $[21];
  }
  useEffect(t7, t8);
};
function _temp(error) {
  return readFragment(useSetBlockchainActionErrorsFragment, error);
}
function _temp2(error_0) {
  return error_0.__typename !== "OrderNotFound";
}
function _temp3(error_1) {
  return error_1.__typename;
}